export enum OtpStatus {
    None = 0,
    Pending = 1,
    Success = 2,
    Fail = 3,
    InvalidOtp = 4
}
